<form [formGroup]="thirdQuestionFormGroup" class="wizard-item">
    <div class="row">
        <div class="col-12 wizard-question l-title-subtitle-align">
            {{'contractModifications.wizard.questions.WhichIsTheAmountYouWantToPayInAdvance' | translate}}
            <span class="l-subtitle">
                {{'contractModifications.wizard.questions.WhichIsTheAmountYouWantToPayInAdvanceSubtitle' | translate}}
            </span>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container">
            <label class="label-input required">
                {{'contractModifications.wizard.amount' | translate}}
            </label>
            <div class="l-numeric-textbox-container">
                <kendo-numerictextbox
                    [spinners]="false"
                    [(ngModel)]="thirdQuestionFormGroup.value.answear"
                    [min]="0"
                    placeholder="{{'contractModifications.wizard.placeholder.typeAmount' | translate}}"
                    formControlName="answear"
                >
                </kendo-numerictextbox>
                <span class="l-currency-symbol">{{contractModificationRequestHeader?.currencyCode}}</span>
            </div>

            <span>
                {{'contractModifications.wizard.mandatory1' | translate}}
                <span class="text-primary fw-bold">*</span>
                {{'contractModifications.wizard.mandatory2' | translate}}
            </span>
        </div>
    </div>

    <div class="d-flex justify-content-center l-next-step-container">
            <button
                class="btn primary-btn"
                [disabled]="thirdQuestionFormGroup.value.answear === null"
                (click)="nextStepHandler(wizardStepsEnum.ContractModification_AmountPayInAdvance, thirdQuestionFormGroup.value.answear)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
    </div>
</form>
